import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

import DynamicImage from 'components/DynamicImage'
import { Text } from 'styles/components/typography'

import {
  InfoIconWrapper,
  Description,
  Info,
  Container,
  Line,
  Box,
  IconStyled,
} from '../../styles'

import { LineWrapper, Item } from './styles'

const BHowOrderEuroBox = ({ path, data }) => (
  <Container>
    <Box>
      <DynamicImage
        image={`${path}/biome-opened-new`}
        imageType="png"
        imageSizes={{ md: 1000 }}
        fitOption="contain"
        alt={'microbime kit'}
      />
    </Box>
    <Description>
      <Info>
        <InfoIconWrapper className="pr-15">
          <IconStyled id="color_locker" />
        </InfoIconWrapper>
        <span dangerouslySetInnerHTML={{ __html: data.info }} />
      </Info>
      {data.opened.list.map(
        (desc, index) =>
          desc && (
            <Fragment key={index}>
              <LineWrapper className={`item-${index} line-${index} pr-15`}>
                <Line />
              </LineWrapper>
              <Item className={`item-${index}`}>
                <Text
                  className="text--muted"
                  dangerouslySetInnerHTML={{ __html: desc }}
                />
              </Item>
            </Fragment>
          ),
      )}
    </Description>
  </Container>
)

BHowOrderEuroBox.propTypes = {
  data: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
}

export default BHowOrderEuroBox
